import type { Theme } from '../../types/theme';

export const airtableTheme: Theme = {
  id: 'airtable',
  name: 'Airtable',
  description: 'Colorful and friendly spreadsheet-database hybrid with blue accents',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/airtable/DESIGN.md',
  visualKeywords: ['colorful', 'spreadsheet', 'friendly', 'grid', 'flexible'],
  colors: {
    background: '#f8f8f8',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#1a1a1a',
    textSecondary: '#6b7280',
    textMuted: '#6b7280',
    border: '#e5e7eb',
    borderSubtle: '#dbdde1',
    primary: '#18bfff',
    primaryHover: '#27ceff',
    primaryActive: '#00a1e1',
    accent: '#18bfff',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'high',
    tone: 'flexible',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
